import { defineComponent as f, ref as p, computed as i, watchPostEffect as g, unref as v, resolveComponent as y, openBlock as d, createElementBlock as u, normalizeClass as m, createElementVNode as b, renderSlot as k, createVNode as $, withModifiers as B, createCommentVNode as O } from "vue";
import { O as h } from "./OrIconButton-BlHCLpeW.mjs";
import { _ as C } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var n = /* @__PURE__ */ ((e) => (e.Tag = "tag", e.Button = "button", e.Reset = "reset", e))(n || {}), s = /* @__PURE__ */ ((e) => (e.Default = "default", e.Danger = "danger", e))(s || {});
const w = [
  // Layout
  "layout-inline-row",
  // Spacing
  "px-sm+ md:px-sm",
  "py-sm md:py-xs",
  "gap-sm+ md:gap-sm",
  // Shape
  "rounded-full",
  // Typography
  "typography-caption-regular whitespace-nowrap"
], T = {
  [n.Tag]: [
    // Interactivity
    "interactivity-select"
  ],
  [n.Button]: [
    // Interactivity
    "interactivity-click"
  ],
  [n.Reset]: [
    // Interactivity
    "interactivity-default"
  ]
}, D = {
  [s.Default]: [
    // Theme
    "theme-preset-2-primary",
    "dark:theme-preset-2-primary-dark",
    "theme-foreground-default",
    "dark:theme-foreground-default-dark"
  ],
  [s.Danger]: [
    // Theme
    "theme-preset-2-error",
    "dark:theme-preset-2-error-dark"
  ]
}, S = f({
  name: "OrTag",
  components: {
    OrIconButton: h
  },
  props: {
    variant: {
      type: String,
      default: () => n.Tag
    },
    color: {
      type: String,
      default: () => s.Default
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "click",
    "focus",
    "blur",
    "reset"
  ],
  expose: [
    "root"
  ],
  setup(e) {
    const t = p(), l = i(() => [
      "or-tag-v3",
      ...w,
      ...T[e.variant],
      ...r.value ? [] : D[e.color]
    ]), r = i(() => !["default", "danger"].includes(e.color));
    return g(() => {
      const a = v(t);
      a && Object.assign(a.style, {
        backgroundColor: r.value ? `${e.color}1f` : "",
        color: r.value ? e.color : ""
      });
    }), {
      root: t,
      rootStyles: l,
      custom: r
    };
  }
}), E = ["tabindex", "disabled"], I = { class: "truncate" }, N = {
  key: 0,
  class: /* @__PURE__ */ m(["layout-inline-row", "-m-[4px] md:-m-[2px]"])
};
function R(e, t, l, r, a, V) {
  const c = y("OrIconButton");
  return d(), u("div", {
    ref: "root",
    class: m(e.rootStyles),
    tabindex: !e.disabled && e.variant === "button" ? 0 : null,
    disabled: e.disabled,
    onClick: t[1] || (t[1] = (o) => e.$emit("click", o)),
    onFocus: t[2] || (t[2] = (o) => e.$emit("focus", o)),
    onBlur: t[3] || (t[3] = (o) => e.$emit("blur", o))
  }, [
    b("div", I, [
      k(e.$slots, "default")
    ]),
    e.variant === "reset" ? (d(), u("div", N, [
      $(c, {
        icon: "close",
        color: e.custom ? "inherit" : e.color,
        disabled: e.disabled,
        onClick: t[0] || (t[0] = B((o) => e.$emit("reset"), ["stop"]))
      }, null, 8, ["color", "disabled"])
    ])) : O("", !0)
  ], 42, E);
}
const M = /* @__PURE__ */ C(S, [["render", R]]);
export {
  M as O,
  n as T,
  s as a
};
//# sourceMappingURL=OrTag-Bixe0EQq.mjs.map
